import { render, staticRenderFns } from "./ServiceConsultation.vue?vue&type=template&id=dfd51ba0&scoped=true&"
import script from "./ServiceConsultation.vue?vue&type=script&lang=js&"
export * from "./ServiceConsultation.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConsultation.vue?vue&type=style&index=0&id=dfd51ba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd51ba0",
  null
  
)

export default component.exports